import React, { Component } from 'react'
import { Form } from 'redux-form'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'

export default class IncomingWebhookForm extends Component {
  render() {
    const { handleSubmit, className, onSubmit, node, nodeInfo } = this.props
    const submit = data => onSubmit(node, { extras: data })

    return (
      <Form onSubmit={handleSubmit(submit)} className={className}>
        <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
          This node will trigger whenever the selected number is called. Note, each number can only
          be attached to one flow.{' '}
          <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
            {' '}
            Learn more.
          </a>
        </div>
        {/* <Field
          name="numberSid"
          options={ numberOptions }
          component={ Inpuit }
          onChangeAlt={ numberSd => change('number', find(numberOptions, ['value', numberSid]).number) }
          label="Number"
          validate={ [vRequired] }
        /> */}
        <div className={sLay.flex} />
        <div className={cn(sLay['layout-column'])}>
          <Button type="submit" color="tertiary" rect>
            Save Node
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/IncomingWebhook/IncomingWebhookForm.jsx